import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RbSwitchChange } from '@inst-iot/bosch-angular-ui-components'
import { Permissions } from 'src/app/core/enums/permissions.enum'

@Component({
  selector: 'app-advanced-settings',
  templateUrl: './advanced-settings.component.html',
  styleUrl: './advanced-settings.component.scss',
  standalone: false,
})
export class AdvancedSettingsComponent {
  @Input() confidence: number = 1.0
  @Input() dfrs: 'DFRS_NONE' | 'DFRS_ONLY' | 'DFRS_PARTLY' = 'DFRS_NONE'
  @Input() isExpanded: boolean = false
  @Input() requiredPermissions: string[] = [Permissions.RCS_Apps_All]

  @Output() confidenceChange = new EventEmitter<number>()
  @Output() dfrsChange = new EventEmitter<string>()
  @Output() isExpandedChange = new EventEmitter<boolean>()

  public dfrsOptions = ['DFRS_NONE', 'DFRS_PARTLY', 'DFRS_ONLY']

  public Permissions = Permissions

  // Update the method to handle RbSwitchChange event
  toggleAdvancedSettings(event: RbSwitchChange): void {
    // Extract the checked value from the RbSwitchChange event
    this.isExpanded = event.checked
    this.isExpandedChange.emit(this.isExpanded)

    // Reset to default values when disabling (not collapsing)
    if (!this.isExpanded) {
      this.confidence = 1.0
      this.dfrs = 'DFRS_NONE'
      this.confidenceChange.emit(this.confidence)
      this.dfrsChange.emit(this.dfrs)
    }
  }

  updateConfidence(event: Event): void {
    const target = event.target as HTMLInputElement
    let value = parseFloat(target.value)

    // Ensure value is within bounds and properly stepped
    value = Math.max(0, Math.min(1, value))
    value = Math.round(value * 100) / 100 // Round to nearest 0.01

    this.confidence = value
    target.value = value.toString()
    this.confidenceChange.emit(this.confidence)
  }

  updateDfrsClassification(event: Event): void {
    const target = event.target as HTMLSelectElement
    this.dfrs = target.value as 'DFRS_NONE' | 'DFRS_ONLY' | 'DFRS_PARTLY'
    this.dfrsChange.emit(this.dfrs)
  }
}
